import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardText } from 'material-ui';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import { Line } from 'react-chartjs-2';
import { useGraphConfig } from 'helpers/graph';

const StatisticsGraph = (props) => {
    const {
        dataSet,
        isLoading,
        labelCurrentMonth,
        labelPreviousYear,
        styles,
        title,
    } = props;

    const tooltipItemLabelCallback = function (tooltipItem) {
        return Number(tooltipItem.yLabel).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    };

    const options = useGraphConfig(tooltipItemLabelCallback);

    return (
        <Card style={ styles.column } containerStyle={ { padding: '10px 0', width: '100%' } }>
            { isLoading &&
                <RefreshIndicator size={ 40 } top={ 30 } left={ 0 } status={ 'loading' } style={ { marginLeft: '50%' } } />
            }

            <CardText>
                <div style={ styles.card.title }>{ title }</div>

                <div style={ { width: '96%', height: '400px', margin: '0 auto' } }>
                    { dataSet &&
                        <Line
                            data={ {
                                labels: dataSet.dates,
                                datasets: [
                                    {
                                        backgroundColor: 'transparent',
                                        borderColor: styles.brand.red,
                                        borderJoinStyle: 'miter',
                                        borderWidth: 2,
                                        data: dataSet.datasets[0],
                                        fill: false,
                                        label: labelCurrentMonth,
                                        pointBackgroundColor: styles.brand.red,
                                        pointBorderColor: styles.brand.red,
                                    },
                                    {
                                        backgroundColor: 'transparent',
                                        borderColor: styles.brand.green,
                                        borderDash: [
                                            5,
                                            5,
                                        ],
                                        borderJoinStyle: 'miter',
                                        borderWidth: 1,
                                        data: dataSet.datasets[1],
                                        fill: false,
                                        label: labelPreviousYear,
                                        pointBackgroundColor: styles.brand.green,
                                        pointBorderColor: styles.brand.green,

                                    },
                                ],
                            } }
                            options={ options }
                        />
                    }
                </div>
            </CardText>
        </Card>
    );
};

StatisticsGraph.propTypes = {
    dataSet: PropTypes.object,
    isLoading: PropTypes.bool,
    labelCurrentMonth: PropTypes.string,
    labelPreviousYear: PropTypes.string,
    styles: PropTypes.object,
    title: PropTypes.string,
};

export default StatisticsGraph;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/StatisticsGraph.js